module.exports = __webpack_public_path__ + "static/media/image2.bb2692b9.png";